import { defineComponent, ref, computed, onMounted, onUnmounted } from "vue";
import "../../../../services/main.mjs";
import { roomService } from "../../../../services/roomService.mjs";
import "../../../../locales/index.mjs";
import "@tencentcloud/tuiroom-engine-js";
import "../../../../utils/environment.mjs";
import "mitt";
import "../../../../services/manager/roomActionManager.mjs";
import "@tencentcloud/tui-core";
import { MetricsKey } from "../../../../services/manager/dataReportManager.mjs";
import { AI_TASK } from "../../../../services/function/aiTask.mjs";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AISubtitles",
  setup(__props) {
    const subtitleMessages = ref({});
    const subtitleLines = computed(() => {
      const arr = Object.keys(subtitleMessages.value).map((userId) => {
        return subtitleMessages.value[userId];
      });
      return arr.sort((a, b) => a.startMsTs - b.startMsTs);
    });
    const handleAISubtitles = (data) => {
      if (!data) return;
      subtitleMessages.value = Object.assign({}, data.subtitleMessages);
    };
    onMounted(() => {
      roomService.dataReportManager.reportCount(MetricsKey.aiTask);
      roomService.aiTask.on(AI_TASK.TRANSCRIPTION_TASK, handleAISubtitles);
    });
    onUnmounted(() => {
      roomService.aiTask.off(AI_TASK.TRANSCRIPTION_TASK, handleAISubtitles);
    });
    return { __sfc: true, subtitleMessages, subtitleLines, handleAISubtitles, roomService };
  }
});
export {
  _sfc_main as default
};
